import { ArrowUpward } from "@clockwise/design-system/icons";
import { makeStyles, Tooltip } from "@material-ui/core";
import classNames from "classnames";
import * as React from "react";
import { colors } from "../../../../styles/color.styles";
import { weight } from "../../../../styles/type.styles";
import { formatNumberAsAbbreviation } from "../overview.util";

const useStyles = makeStyles({
  percentChange__green: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    "& > svg": {
      fill: colors.green.darker,
      height: 14,
      width: 14,
    },
    "& > span": {
      fontWeight: weight.bold,
      color: colors.green.darker,
      margin: "0 4px 0 8px",
    },
  },
});

const PercentIncreaseSubtitle = ({
  current,
  previous,
  helpText,
}: {
  current: number;
  previous: number;
} & { helpText: string }) => {
  const classes = useStyles();

  const percentChange = Math.round(((current - previous) * 100) / previous);
  const formattedPercentChange = formatNumberAsAbbreviation(percentChange);

  return (
    <Tooltip title={helpText} placement="bottom-start">
      <div
        className={classNames({
          [classes.percentChange__green]: percentChange && percentChange > 0,
        })}
      >
        {percentChange > 0 && <ArrowUpward />}
        <span>
          {formattedPercentChange}
          %&nbsp;
        </span>
        vs. previous period
      </div>
    </Tooltip>
  );
};

export default PercentIncreaseSubtitle;
